// Verrou de navigation global léger (sans re-render). Permet à un écran (ex : dépôt intelligent
// pendant l'analyse IA) de bloquer les changements de page tant qu'une opération critique tourne,
// avec une confirmation avant de quitter. Lu paresseusement au moment du clic → pas de re-render.
const state = { blocked: false, message: "" };

export const setNavBlock = (blocked, message = "") => {
  state.blocked = !!blocked;
  state.message = message;
};

export const isNavBlocked = () => state.blocked;

// true si on peut naviguer (pas bloqué, ou l'utilisateur a confirmé). Lève le verrou si confirmé.
export const confirmLeaveIfBlocked = () => {
  if (!state.blocked) return true;
  const ok = window.confirm(state.message || "Opération en cours. Quitter quand même ?");
  if (ok) setNavBlock(false);
  return ok;
};
